module.exports = __webpack_public_path__ + "images/ef05ebc037d0c25ad924bdb6dfcfa336.svg";